import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

import { CircularProgress } from '@mui/material';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';

import Alert, { useAlert } from 'components/snacks/Alert';

import { numSeperator } from 'utils/DataBase';
import { checkDiscountCode, orderPayment } from 'api/Api';
import LoadingButton from "components/button/LoadingButton";

const Card = () => {
  const [validList, setValidList] = useState([
    { validity_id: null, title: null, price: 0 }
  ]);
  const [attrList, setAttrList] = useState([]);
  const [product, setProduct] = useState([
    { product_id: null, title: null, cat_id: null }
  ]);
  const [sum, setSum] = useState(0);
  const [ratio, setRatio] = useState(1);
  const [title, setTitle] = useState('');
  const [code, setCode] = useState('');
  const [codeData, setCodeData] = useState(null);
  const [open, setOpen] = React.useState(false);
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState(null);
  const [card, setCard] = React.useState(false);
  const [showMainMessage, setShowMainMessage] = useState(false);
  const [userInfo, setUserInfo] = useState({});
  const [canntPay, setCanntPay] = useState(false);
  const [loadingBtn, setLoadingBtn] = useState(false) // For loading button

  const alert_timeout = 10000;
  const alertStore = useAlert(alert_timeout);

  const removeCardStorage = () => {
    localStorage.removeItem('product');
    localStorage.removeItem('validList');
    localStorage.removeItem('attrList');
    localStorage.removeItem('sum');
    setOpen(false);
    window.location.pathname = '/';
  };

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 330,
    backgroundColor: 'background.paper',
    border: '1px solid #000',
    borderRadius: '7px',
    boxShadow: 24,
    p: 4
  };

  const payment = () => {
    const formData = new FormData();
    formData.append('product_id', product[0].product_id);
    formData.append('validity_id', validList[0].validity_id);
    formData.append('code', code);
    formData.append('detail_options', JSON.stringify(attrList));
    setLoadingBtn(true)
    orderPayment(formData, (isOk, data) => {
      if (isOk === 1) {
        setShowMainMessage(true);
        setMsg(data.msg_html);
        localStorage.removeItem('product');
        localStorage.removeItem('validList');
        localStorage.removeItem('attrList');
        // document.getElementById("response_message_card_detail").innerHTML = data.msg;
        alertStore.AddAlert({
          key: 'success-payment',
          message: data.msg,
          severity: 'success',
          auto_hide: true
        });
        setTimeout(()=>{
          setLoadingBtn(false)
        }, 1000)
      } else if (isOk === 2) {
        setMsg(data.msg);
        localStorage.removeItem('product');
        localStorage.removeItem('validList');
        localStorage.removeItem('attrList');
        setTimeout(()=>{
          setShowMainMessage(false);
          setLoadingBtn(false)
          window.location = data.url;
        }, 2000)
      } else {
        setShowMainMessage(false);
        alertStore.AddAlert({
          key: '400',
          message: data.msg,
          severity: 'error',
          auto_hide: true
        });
        setTimeout(()=>{
          setLoadingBtn(false)
        }, 1000)
      }
    });
  };

  useEffect(() => {
    let product_store = JSON.parse(localStorage.getItem('product'));
    let valid_store = JSON.parse(localStorage.getItem('validList'));
    let attr_store = JSON.parse(localStorage.getItem('attrList'));
    let sum_store = JSON.parse(localStorage.getItem('sum'));
    let ratio_val = JSON.parse(localStorage.getItem('ratio'));
    setCanntPay(JSON.parse(localStorage.getItem('cant_pay')) ? JSON.parse(localStorage.getItem('cant_pay')) : false)
    if (ratio_val > 1){
      setRatio(ratio_val)
    }
    if (product_store && valid_store && attr_store) {
      setCard(true);
    }

    if (card) {
      setValidList(valid_store);
      setAttrList(attr_store);
      setProduct(product_store);
      setSum(sum_store);
      setTitle(valid_store[0].title);
    }
    try {
      setUserInfo(JSON.parse(localStorage.getItem('user_info')));
    } catch (e) {
      console.log(e);
    }
  }, [card]);

  useEffect(() => {
    try {
      document.getElementById('response_message_card_detail').innerHTML = msg;
    } catch (e) {
      console.log(e);
    }
  }, [msg]);

  const checkDiscount = () => {
    const finalPrice =
      sum + validList[0].price + 0.09 * (sum + validList[0].price);
    const productId = product[0].product_id;
    if (code) {
      setLoading(true);
      checkDiscountCode(code, productId, finalPrice, (isOk, data) => {
        if (isOk) {
          setCodeData({
            discount_price: data.discount_price,
            price: data.price,
            tax_value: data.tax_value
          });
          alertStore.AddAlert({
            key: '400',
            message: data.msg,
            severity: 'success',
            auto_hide: true
          });
        } else {
          alertStore.AddAlert({
            key: '400',
            message: data.msg,
            severity: 'error',
            auto_hide: true
          });
        }
        setLoading(false);
      });
    } else {
      alertStore.AddAlert({
        key: '400',
        message: 'کد تخفیف موجود نیست!',
        severity: 'error',
        auto_hide: true
      });
    }
  };

  return (
    <>
      {showMainMessage ? (
        <>
          <div className="d-flex flex-column justify-content-center align-items-center min-h-80 card">
            <div style={{width:'100px', height: '100px'}}>
              <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="#47BE7D"
                  className="bi bi-check2-circle"
                  viewBox="0 0 16 16"
              >
                <path d="M2.5 8a5.5 5.5 0 0 1 8.25-4.764.5.5 0 0 0 .5-.866A6.5 6.5 0 1 0 14.5 8a.5.5 0 0 0-1 0 5.5 5.5 0 1 1-11 0z" />
                <path d="M15.354 3.354a.5.5 0 0 0-.708-.708L8 9.293 5.354 6.646a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0l7-7z" />
              </svg>
            </div>
            <h5 className={'mt-5 text-center'} id={'response_message_card_detail'}></h5>
            <div className="d-flex mt-5">
              <Link to={'/'} className={'btn btn-secondary'}>
                داشبورد
              </Link>
              <Link to={'/factors'} className={'btn btn-info ms-5'}>
                لیست فاکتور ها
              </Link>
            </div>
          </div>
        </>
      ) : (
        <>
          {loading ? (
            <div
              className={
                'min-h-80 d-flex justify-content-center align-items-center'
              }
            >
              <div
                className={
                  'd-flex justify-content-start align-items-center ms-5'
                }
              >
                <h1>در حال بارگذاری...</h1>
                <Box sx={{ display: 'flex', marginRight: '20px' }}>
                  <CircularProgress />
                </Box>
              </div>
            </div>
          ) : (
            <>
              {card ? (
                <Paper elevation={1}>
                  <div className="row mt-3">
                    <div className="col-11 col-lg-10 mx-auto">
                      <h3 className="pt-50 mb-5 d-flex align-items-center">
                        <div className="service-icon bg-danger ml-2">
                          <p className="mb-n3">
                            <i className="bi bi-cash-coin text-white f-15" />
                          </p>
                        </div>
                        <span className="f-13 ms-3">بررسی نهایی و پرداخت</span>
                      </h3>
                      <div className="cart_detail pb-50">
                        <div className="cart__list">
                          <ul className="p-0 w-100 mb-4">
                            <li className="main__cart__list">
                              <div className="produst__title">
                                <div className="d-lg-flex d-none product__status bg-primary">
                                  <span className="m-0 f-22 line-height-2">
                                    <i className="bi bi-hdd-network text-white f-12" />
                                  </span>
                                </div>
                                <div className="d-flex flex-lg-row flex-column justify-content-between align-items-start w-100">
                                  <div
                                    className={
                                      'd-flex flex-lg-row flex-column justify-content-between align-items-start w-100 pe-5'
                                    }
                                  >
                                    <div
                                      className={
                                        'd-flex flex-column justify-content-start align-items-start'
                                      }
                                    >
                                      <div className="d-flex align-items-center f-12 f-bold flex-wrap">
                                        <span className="me-1">سرور مجازی</span>
                                        <span className={''}>
                                          {product && product[0].title}
                                        </span>
                                      </div>
                                      <ul className={'mt-3'}>
                                        <li
                                          className={
                                            'd-flex justify-content-start align-items-center mb-2 flex-wrap'
                                          }
                                        >
                                          <span className="bullet bullet-dot bg-primary me-2 h-8px w-8px" />
                                          <span style={{ whiteSpace: 'wrap' }}>
                                            دوره زمانی{' '}
                                          </span>
                                          <span className={'mx-1'}>/</span>
                                          <span
                                            className={'flex-wrap text-muted'}
                                            style={{ whiteSpace: 'wrap' }}
                                          >
                                            {title}
                                          </span>
                                        </li>
                                        {attrList &&
                                          attrList.map((attrItem, index) => (
                                            <li
                                              key={index}
                                              className={
                                                'd-flex justify-content-start align-items-center mb-2 flex-wrap'
                                              }
                                            >
                                              <span className="bullet bullet-dot bg-primary me-2 h-8px w-8px" />
                                              <span
                                                style={{ whiteSpace: 'wrap' }}
                                              >
                                                {attrItem.attr_name}
                                              </span>

                                              <span>
  {(() => {
    const matchedItem = attrItem;
    return matchedItem ? (
        <div className={'d-flex align-items-center'} style={{gap:'4px'}}>
          <span>/</span>
          <span className={'text-muted'}>{matchedItem.name}</span>
          {matchedItem.price !== 0 ? (
              <>
                <span className="mx-1 text-muted">:</span>
                <span className={'text-muted'}>
                  <span>{ratio > 1 ? ratio + ' * ': ''}</span>
                  <span>{matchedItem.price_text}</span>
                </span>
              </>
          ) : ''}
        </div>
    ) : null;
  })()}
</span>


                                            </li>
                                          ))}
                                        <li
                                          className={'d-lg-none d-block mt-5'}
                                        >
                                          قیمت:
                                          {
                                            <span className={'me-1'}>
                                              {' '}
                                              {numSeperator(
                                                sum + validList[0].price
                                              )}
                                            </span>
                                          }
                                        </li>
                                      </ul>
                                    </div>
                                    <div
                                      className={
                                        'd-lg-flex d-none justify-content-lg-start justify-content-end align-items-center'
                                      }
                                    >
                                      <span className={'pe-1'}>
                                        {numSeperator(sum + validList[0].price)}
                                      </span>
                                      <span>تومان</span>
                                    </div>
                                  </div>
                                  <div
                                    className={
                                      'd-flex justify-content-center align-items-start w-100px mt-lg-0 mt-4'
                                    }
                                  >
                                    <Button
                                      onClick={handleOpen}
                                      style={{
                                        minWidth: 'unset',
                                        padding: 0
                                      }}
                                    >
                                      <i className="bi bi-trash3 text-danger f-16 ms-3" />
                                    </Button>
                                    <Modal
                                      open={open}
                                      // onClose={handleClose}
                                      aria-labelledby="modal-modal-title"
                                      aria-describedby="modal-modal-description"
                                    >
                                      <Box sx={style}>
                                        <Typography
                                          id="modal-modal-title"
                                          variant="h6"
                                          component="h2"
                                          className={'yekan-font'}
                                        >
                                          حذف سبد خرید
                                        </Typography>
                                        <Typography
                                          id="modal-modal-description"
                                          sx={{ mt: 2 }}
                                          className={'yekan-font'}
                                        >
                                          آیا درخواست حذف سبد خرید را دارید؟
                                        </Typography>
                                        <div
                                          className={
                                            'd-flex justify-content-end align-items-center mt-3'
                                          }
                                        >
                                          <Button
                                            variant={'contained'}
                                            color={'info'}
                                            className={'yekan-font me-4'}
                                            onClick={handleClose}
                                          >
                                            انصراف
                                          </Button>
                                          <Button
                                            variant={'contained'}
                                            color={'error'}
                                            className={'yekan-font'}
                                            onClick={removeCardStorage}
                                          >
                                            حذف
                                          </Button>
                                        </div>
                                      </Box>
                                    </Modal>
                                  </div>
                                </div>
                              </div>
                            </li>
                          </ul>
                          <div className="coupon-code">
                            <span className="f-14 d-lg-block d-none">
                              <i className="bi bi-percent f-2 " />
                              کد تخفیف خود را در این بخش وارد نمایید.
                            </span>
                            <div className="coupon-input">
                              <input
                                type="text"
                                name="code"
                                id="discount_code"
                                placeholder="کد تخفیف"
                                style={{
                                  border: '1px solid rgba(0, 157, 255, 0.57)'
                                }}
                                onChange={(e) => setCode(e.target.value)}
                              />
                              <span
                                className="pcoupon-submit discount_check "
                                onClick={checkDiscount}
                              >
                                بررسی
                              </span>
                            </div>
                          </div>
                        </div>
                        <div
                          className="cart-box shadow-sm text-dark"
                          style={{ border: '1px solid #eaeaea' }}
                        >
                          <div className="total-price final-price">
                            <span style={{ fontSize: '13px' }}>
                              مبلغ فاکتور
                            </span>
                            <span>
                              <b style={{ fontSize: '13px' }}>
                                {validList[0].price &&
                                  numSeperator(sum + validList[0].price)}
                              </b>
                              <b
                                style={{ fontSize: '13px' }}
                                className={'ms-1'}
                              >
                                تومان
                              </b>
                            </span>
                          </div>
                          <div className="total-price final-price">
                            <span style={{ fontSize: '13px' }}>
                              مالیات
                              <span
                                className={
                                  'badge badge-light-success text-success f-09 ms-1'
                                }
                                style={{ minWidth: 'unset' }}
                              >
                                {!userInfo?.is_official ? (
                                  <>0 درصد</>
                                ) : (
                                  <>10 درصد</>
                                )}
                              </span>
                            </span>
                            <span>
                              <b
                                className="tax_value"
                                style={{ fontSize: '13px' }}
                              >
                                {!userInfo?.is_official ? (
                                  <>0</>
                                ) : (
                                  <>
                                    {!codeData
                                      ? validList[0].price &&
                                        numSeperator(
                                          Math.round(
                                            0.1 * (sum + validList[0].price)
                                          )
                                        )
                                      : codeData.tax_value}
                                  </>
                                )}
                              </b>
                              <b
                                style={{ fontSize: '13px' }}
                                className={'ms-1'}
                              >
                                تومان
                              </b>
                            </span>
                          </div>

                          <div className="total-price final-price">
                            <span>مجموع هزینه پرداختی</span>
                            <span>
                              <b id="all_pay">
                                {!userInfo?.is_official ? (
                                  <>{numSeperator(sum + validList[0].price)}</>
                                ) : (
                                  <>
                                    {!codeData
                                      ? validList[0].price &&
                                        numSeperator(
                                          Math.round(
                                            sum +
                                              validList[0].price +
                                              0.1 * (sum + validList[0].price)
                                          )
                                        )
                                      : codeData.price}
                                  </>
                                )}
                              </b>
                              <b className={'ms-1'}>تومان</b>
                            </span>
                          </div>
                          <div
                            className={
                              'd-flex justify-content-end align-items-center'
                            }
                          >
                            <LoadingButton
                                loadingBtn={loadingBtn}
                                onClick={payment}
                                custom_class={`bg-primary w-100 mt-4 text-white`}
                                title={canntPay ? 'ثبت درخواست' : 'پرداخت آنلاین'}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </Paper>
              ) : (
                <Paper elevation={1} style={{ width: '100%', padding: '30px' }}>
                  <div
                    className={
                      'd-flex flex-column justify-content-center align-items-center'
                    }
                  >
                    <img
                      src={'./assets/media/cartempty1.png'}
                      width={'250px'}
                    />
                    <h1 className={'f-15 f-bold my-8'}>
                      سبد خرید شما خالی می باشد.
                    </h1>
                  </div>
                </Paper>
              )}
            </>
          )}
        </>
      )}
      {
        <Alert
          alerts={alertStore.alert}
          close={alertStore.RemoveAlert}
          timeout={alert_timeout}
        />
      }
    </>
  );
};

export default Card;
